<template>
    <div>
        <van-nav-bar :title="title"   :fixed="fixed" :placeholder="fplaceholder" :left-arrow="arrow" @click-left="onBack">
            <template #left>
                <span :style="{'color':'#a8a8a8'}">{{lefttext}}</span>
            </template>
            <template #right>
                <span :style="{'padding':'2px 10px','border-radius': '43px','background-color':$abctheme.basecolor,'color':'#fff'}" @click="doclick">发布</span>
            </template>
        </van-nav-bar>
    </div>
</template>
<script>
import {
    NavBar
} from 'vant';
export default {
    name: 'addnav',
    components: {
        [NavBar.name]: NavBar,
    },
    props: {
        title: String,
        lefttext:{
            type:String,
            default:'取消'
        },
        arrow: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: true
        },
        fplaceholder:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{

        }
    },
    methods:{
        onBack() {
            //history.back();
            this.$emit('onBack');
        },
        doclick(){
            this.$emit("doclick");
        }
    }
}
</script>
<style lang="scss" scoped>

</style>